<template>
  <div>
    <el-button type="text" @click="logout" class="logout">
      Logout
      <i class="el-icon-caret-right"></i>
    </el-button>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'HeaderLogout',
  methods: {
    ...mapActions({
      logoutAction: 'oauth/logoutAction'
    }),
    logout () {
      this.$confirm('Please SAVE your work properly!', 'Logout', {
        distinguishCancelAndClose: true,
        confirmButtonText: 'Sure',
        cancelButtonText: 'Cancel'
      })
        .then(() => {
          this.logoutAction().then(() => this.$router.replace('/'))
        })
        .catch(() => {

        })
    }
  }
}
</script>

<style scoped lang="scss">
.logout {
  color: white;
  margin: 0 16px;
  font-size: 14px;
}
</style>
